var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2976_23243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 4.58172 5.58172 1 10 1H32C36.4183 1 40 4.58172 40 9V31C40 35.4183 36.4183 39 32 39H10C5.58172 39 2 35.4183 2 31V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H34C37.3137 1 40 3.68629 40 7V33C40 36.3137 37.3137 39 34 39H8C4.68629 39 2 36.3137 2 33V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7071 15.2929C24.0976 15.6834 24.0976 16.3166 23.7071 16.7071L20.4142 20L23.7071 23.2929C24.0976 23.6834 24.0976 24.3166 23.7071 24.7071C23.3166 25.0976 22.6834 25.0976 22.2929 24.7071L18.2929 20.7071C17.9024 20.3166 17.9024 19.6834 18.2929 19.2929L22.2929 15.2929C22.6834 14.9024 23.3166 14.9024 23.7071 15.2929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2H34V0H8V2ZM39 7V33H41V7H39ZM34 38H8V40H34V38ZM3 33V7H1V33H3ZM8 38C5.23858 38 3 35.7614 3 33H1C1 36.866 4.13401 40 8 40V38ZM39 33C39 35.7614 36.7614 38 34 38V40C37.866 40 41 36.866 41 33H39ZM34 2C36.7614 2 39 4.23858 39 7H41C41 3.13401 37.866 0 34 0V2ZM8 0C4.13401 0 1 3.13401 1 7H3C3 4.23858 5.23858 2 8 2V0Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2H32V0H10V2ZM39 9V31H41V9H39ZM32 38H10V40H32V38ZM3 31V9H1V31H3ZM10 38C6.13401 38 3 34.866 3 31H1C1 35.9706 5.02944 40 10 40V38ZM39 31C39 34.866 35.866 38 32 38V40C36.9706 40 41 35.9706 41 31H39ZM32 2C35.866 2 39 5.13401 39 9H41C41 4.02944 36.9706 0 32 0V2ZM10 0C5.02944 0 1 4.02944 1 9H3C3 5.13401 6.13401 2 10 2V0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2976_23243",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2976_23243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2976_23243",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLeft);
export default __webpack_public_path__ + "static/media/square-left.99824355250a8afd6a3f6d8c5d898607.svg";
export { ForwardRef as ReactComponent };